import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { FiClock, FiArrowLeft } from 'react-icons/fi';

export default function BlogDetail() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/blogs', {
      headers: {
        'Authorization': 'Basic asrm:asrm@2026'
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch');
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          const found = data.find(b => b.id.toString() === id);
          if (found) {
            setBlog(found);
          } else {
            navigate('/blogs');
          }
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch blog:", err);
        navigate('/blogs');
      });
  }, [id, navigate]);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '100px 0' }}>Loading...</div>;
  }

  if (!blog) return null;

  return (
    <div className="page-wrapper">
      <div className="page-hero" style={{ padding: '20px 0' }}>
        <div className="container" style={{ textAlign: 'left', marginBottom: '10px' }}>
          <Link to="/blogs" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--primary)', textDecoration: 'none', fontWeight: 600, transition: 'color 0.2s ease' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--primary-dark)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--primary)'}
          >
            <FiArrowLeft /> Back
          </Link>
        </div>
        <div className="container" style={{ maxWidth: '800px', textAlign: 'left' }}>
          <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', textAlign: 'left' }}>{blog.title}</h1>
          <div style={{ display: 'flex', gap: '24px', color: 'var(--text-muted)', fontSize: '0.95rem', fontWeight: 500 }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><FiClock /> {blog.dated}</span>
          </div>
        </div>
      </div>

      <main style={{ padding: '20px 0 60px', background: 'var(--off-white)', minHeight: '50vh' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div style={{ background: 'var(--white)', padding: '40px', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-sm)' }}>
            {blog.image_url && (
              <img src={blog.image_url} alt={blog.title} style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', borderRadius: 'var(--radius-sm)', marginBottom: '32px' }} />
            )}
            <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.8, color: 'var(--text-dark)', fontSize: '1.05rem', textAlign: 'justify' }}>
              {blog.description}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
